import styled from 'styled-components';

const SidebarComponent = styled.article`
  padding: 15px 20px;
  border-radius: 4px;
  background-color: ${props => props.theme.secondaryColorLight7Lighten};
  box-shadow: 0px 2px 3px ${props => props.theme.lightShadowColor};
  margin: 20px 0px;

  &&&:first-child {
    margin-top: 0px;
  }
`;

export default SidebarComponent;
